<template>
    <div class="custom-select-wrapper">
        <select :id="id" ref="selectElement" class="custom-select" multiple></select>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount, nextTick, defineProps, defineEmits } from "vue";
import Choices from "choices.js";

const props = defineProps({
    id: { type: String, required: true },
    options: { type: Array, required: true },
    modelValue: { type: Array, default: () => [] }
});

const emit = defineEmits(["update:modelValue"]);
const selectElement = ref(null);
let choicesInstance = null;

const initChoices = () => {
    if (selectElement.value) {
        choicesInstance = new Choices(selectElement.value, {
            allowHTML: true,
            removeItemButton: true,
            shouldSort: false,
            searchEnabled: true,
            searchPlaceholderValue: 'Buscar especialidades...',
            noResultsText: 'No se encontraron resultados',
            itemSelectText: 'Click para seleccionar',
            position: 'bottom' // Asegurar que se muestre debajo
        });

        // Load initial options
        choicesInstance.setChoices(props.options, "value", "text", true);

        // Ensure the correct value is displayed
        updateSelectedValue();

        // Listen to user selection and update v-model
        selectElement.value.addEventListener("change", (event) => {
            const selectedValues = Array.from(event.target.options)
                .filter(option => option.selected)
                .map(option => option.value);
            emit("update:modelValue", selectedValues);
        });
    }
};

// Function to update selection in Choices.js
const updateSelectedValue = () => {
    if (choicesInstance) {
        choicesInstance.setChoiceByValue(props.modelValue);
    }
};

// Watch for changes in modelValue and update Choices.js
watch(() => props.modelValue, () => {
    updateSelectedValue();
});

onMounted(async () => {
    await nextTick();
    initChoices();
});

onBeforeUnmount(() => {
    if (choicesInstance) {
        choicesInstance.destroy();
        choicesInstance = null;
    }
});
</script>

<style scoped>
.custom-select-wrapper {
    width: 100%;
    position: relative;
    z-index: 200;
}

/* Asegurar que el dropdown sea visible */
.custom-select-wrapper :deep(.choices__list--dropdown) {
    z-index: 9999 !important;
    position: absolute !important;
}
</style>
